import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { ProjectId } from 'api/models';
import { ProjectPhase } from 'api/project';
import { Action, EventType, ObjectType, SocketData } from 'api/pushes';
import { getProjectDetailQueryKey } from 'queries/common';
import {
  ALL_PROJECTS_QUERY_KEY,
  PROJECTS_META_QUERY_KEY,
} from 'queries/constants';
import { useProjectWSUpdates } from '../use-project-ws-updates';

export const useProjectPhaseWebsocket = ([, projectId]: ProjectId): void => {
  const queryClient = useQueryClient();

  const handleProjectPhaseSocketUpdates = useCallback(
    async (socketData: SocketData<ProjectPhase>) => {
      switch (socketData.action) {
        case Action.Update:
        case Action.Create:
        case Action.Delete:
          await queryClient.invalidateQueries(ALL_PROJECTS_QUERY_KEY);
          await queryClient.invalidateQueries(PROJECTS_META_QUERY_KEY);
          await queryClient.invalidateQueries(
            getProjectDetailQueryKey(ProjectId(socketData.projectId)),
          );
          break;

        default:
      }
    },
    [queryClient],
  );

  useProjectWSUpdates(
    projectId,
    handleProjectPhaseSocketUpdates,
    EventType(Action.Create, ObjectType.ProjectPhase),
  );

  useProjectWSUpdates(
    projectId,
    handleProjectPhaseSocketUpdates,
    EventType(Action.Update, ObjectType.ProjectPhase),
  );

  useProjectWSUpdates(
    projectId,
    handleProjectPhaseSocketUpdates,
    EventType(Action.Delete, ObjectType.ProjectPhase),
  );
};
